export default __webpack_public_path__ + "static/media/amms-graph.02c64a44.svg";